import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapUsersAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.customerManagement?.addUserResponse, currentState.customerManagement?.addUserResponse, {
    successEventName: "users_created_user",
    errorEventName: "users_got_user_error"
  }),
  ...mapStaticMutation(previousState.integrations?.addDataExportDumpRequestStatus, currentState.integrations?.addDataExportDumpRequestStatus, {
    successEventName: "users_requested_data_export",
    errorEventName: "users_got_data_export_error"
  }),
  ...mapStaticMutation(previousState.integrations?.removeDataExportDumpRequestStatus, currentState.integrations?.removeDataExportDumpRequestStatus, {
    successEventName: "users_deleted_data_export_request",
    errorEventName: "users_got_data_export_error"
  })
];
